import { type FC } from "react";

import { type Filters } from "../../../utils/queryUtils";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getCampaignsFilters } from "./campaignsFilters";

export interface CampaignsFilterFormForPacksProps {
  filterOptions: Filters;
  updateFilter: (filter: Filters) => void;
  filter: Filters;
}

const items = getCampaignsFilters(false);

export const CampaignsFilterFormForPacks: FC<CampaignsFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  updateFilter,
}) => <FilterFormBuilder filterOptions={filterOptions} filter={filter} updateFilter={updateFilter} items={items} />;
